export interface CurrentTimeMarkerLineProps {
  /** Px offset inside the row's grid — 0 is the timeline's start hour. */
  left: number;
  /** Tailwind z-class from the view's layer scale (see lib/scheduleLayers). */
  zClass: string;
  /** Extra px of height to bridge the gap to the row below (0 = flush). */
  bridge?: number;
}

/**
 * The vertical "now" line, drawn once per timeline row.
 *
 * Per row, not once across the whole canvas: that keeps the line inside the
 * schedule grid, so it can't bleed above the first row or below the last one —
 * where it would show up over / under the sticky stage and custom-subject
 * labels. Horizontally the row's own sticky label column covers it (the line
 * sits one layer below it), so a scrolled-away marker simply disappears.
 */
export function CurrentTimeMarkerLine({ left, zClass, bridge = 0 }: CurrentTimeMarkerLineProps) {
  return (
    <div
      aria-hidden
      data-testid="current-time-marker-line"
      className={`pointer-events-none absolute top-0 w-[3px] bg-[#d1ff38] ${zClass}`}
      style={{ left: `${left}px`, height: bridge ? `calc(100% + ${bridge}px)` : "100%" }}
    />
  );
}
